import studentRoutes from './student/'; //Segmentacion de pantallas

export default [
  {
    path: '/student',
    name: 'student-menu',
    component: () => import('@/views/student/Menu.vue'),
    meta: { IsParent: true },
  },
  {
    path: '/student/Evaluations',
    name: 'Evaluations',
    component: () => import('@/views/student/Evaluations/Evaluations.vue'),
    props: true,
  },
  {
    path: '/student/documents',
    name: 'studentdocuments',
    component: () => import('@/components/student/Documents.vue'),
  },
  {
    path: '/student/AdditionalEvaluations',
    name: 'Additional',
    component: () =>
      import('@/views/student/AdditionalEvaluations/Additionals.vue'),
  },
  {
    path: '/student/AddEditEvaluations',
    name: 'AddEditEvaluations',
    component: () =>
      import('@/views/student/AdditionalEvaluations/AddEditEvaluations.vue'),
  },
  {
    path: '/student/EditEvaluations',
    name: 'EditEvaluation',
    component: () =>
      import(
        '@/views/student/evaluation-request-managment/components/DetailEvaluation.vue'
      ),
  },
  {
    path: '/student/egress/addeditegress',
    name: 'AddEditEgress',
    component: () => import('@/views/student/egress/AddEditEgress.vue'),
  },
  {
    path: '/student/transferhistory',
    name: 'TransferHistory',
    component: () => import('@/views/student/TransferHistory.vue'),
  },
  {
    path: '/student/ProvisionalRemedyRequest',
    name: 'ProvisionalRemedyRequest',
    component: () =>
      import('@/components/student/ProvisionalRemedyRequest.vue'),
  },
  {
    path: '/student/transferhistory/form',
    name: 'FormTransferHistory',
    component: () => import('@/views/student/AddEditTransfers.vue'),
  },
  {
    path: '/student/evaluationdiscussion',
    name: 'studentEvaluationDiscussion',
    component: () => import('@/components/pei/EvaluationDiscussion.vue'),
    props: true,
  },
  {
    path: '/student/TriannualProcessMain',
    name: 'TriannualProcessMain',
    component: () =>
      import(
        '@/components/triannualDeterminationProcess/TriannualDeterminationProccessMain.vue'
      ),
  },
  {
    path: '/student/AddProcessDeterminationTriannual',
    name: 'AddProcessDeterminationTriannual',
    component: () => import('@/views/student/triannual-determination/Add.vue'),
  },
  {
    path: '/student/ProcessDeterminationTriannualView/:evaluationDateId?',
    name: 'ProcessDeterminationTriannualView',
    component: () => import('@/views/student/triannual-determination/Add.vue'),
  },
  {
    path: '/student/ProcessDeterminationTriannualEdit/:evaluationDateId?',
    name: 'ProcessDeterminationTriannualEdit',
    component: () => import('@/views/student/triannual-determination/Add.vue'),
  },
  {
    path: '/student/registryhistory',
    name: 'StudentHistory',
    component: () => import('@/components/student/registry/History.vue'),
  },
  {
    path: '/student/registrygeneral',
    name: 'StudentRegistry',
    component: () => import('@/components/student/registry/Master.vue'),
  },
  {
    path: '/student/discipline',
    name: 'Discipline',
    component: () => import('@/components/student/Discipline.vue'),
  },
  {
    path: '/student/egress/historyegress',
    name: 'Egress',
    component: () => import('@/views/student/egress/HistoryEgress.vue'),
  },
  {
    path: '/student/registrations',
    name: 'RegistrationPage',
    component: () =>
      import('@/views/student/Registration/RegistrationPage.vue'),
  },
  {
    path: '/student/registry',
    name: 'Registry',
    component: () => import('@/views/student/Registration/Registry.vue'),
  },
  {
    path: '/student/studentrecords/historystudentrecords',
    name: 'studentRecordSearchHistory',
    component: () =>
      import(
        '@/components/student/historyStudentRecords/studentRecordSearchHistory.vue'
      ),
  },
  {
    path:
      '/student/comments/commentshistory/:studentSieId?/:categoryId?/:academicYearId?',
    name: 'studentSearchComment',
    component: () => import('@/views/comments/history/CommentsHistory.vue'),
  },
  {
    path: '/student/comments/addcomment/:studentSieId?/:categoryId?',
    name: 'studentAddComment',
    component: () =>
      import('@/components/student/comments/components/AddComment.vue'),
  },
  {
    path: '/student/comments/edit/:commentId?',
    name: 'studentEditComment',
    component: () =>
      import('@/components/student/comments/components/AddComment.vue'),
  },
  {
    path: '/student/reportschoolsdiscipline',
    name: 'ReportSchoolsDiscipline',
    component: () => import('@/views/student/ReportSchoolsDiscipline.vue'),
  },
  {
    path: '/discipline/add',
    name: 'AddDiscipline',
    props: true,
    component: () => import('@/components/discipline/AddDiscipline.vue'),
  },
  {
    path: '/student/inforrechassistancereferrals',
    name: 'InforTechAssistanceReferralsView',
    component: () => import('@/views/student/InforTechAssistanceReferrals.vue'),
  },
  {
    path: '/student/intervention',
    name: 'studentIntervention',
    component: () =>
      import('@/components/student/intervention/Intervention.vue'),
  },
  {
    path: '/student/rlvevidence',
    component: () => import('@/views/student/RLVEvidences/Wrapper.vue'),
    children: [
      {
        path: '',
        name: 'rlvevidence',
        component: () => import('@/views/student/RLVEvidences/rlvEvidence.vue'),
      },
      {
        path: '/student/rlvevidence/history',
        name: 'rlvHistory',
        component: () =>
          import('@/views/student/RLVEvidences/components/RLVHistory.vue'),
      },
    ],
  },

  {
    path: '/student/parentInventory',
    name: 'parentInventory',
    component: () =>
      import('@/views/student/ParentInventory/parentInventory.vue'),
  },

  {
    path: '/student/parentInventory/sampleInventory',
    name: 'SampleInventory',
    component: () =>
      import('@/views/student/ParentInventory/SampleInventory.vue'),
  },
  {
    path: '/student/parentInventory/sampleTable/:fiscalYearId?',
    name: 'SampleTable',
    component: () =>
      import('@/views/student/ParentInventory/SampleInventory.vue'),
  },
  {
    path: '/student/disciplinereportschool',
    name: 'UnreportedDisciplines',
    component: () =>
      import('@/views/student/UnreportedDisciplines/UnreportedDisciplines.vue'),
  },
  {
    path: '/student/quotes/AppointmentManagement',
    component: () => import('@/views/student/quotes/Wrapper.vue'),
    children: [
      {
        path: '',
        name: 'AppointmentManagement',
        component: () =>
          import('@/views/student/quotes/AppointmentManagementWrapper.vue'),
      },
      {
        path: 'historical/:client',
        name: 'AppointmentHistorical',
        component: () =>
          import('@/views/student/quotes/AppointmentHistoricalWrapper.vue'),
      },
      {
        path: '/appointmentComplete/:clientAppointmentId',
        name: 'AppointmentComplete',
        component: () =>
          import('@/views/student/quotes/AppointmentCompleteWrapper.vue'),
      },
      {
        path: '/appointmentNewSpaceCoordination/:clientAppointmentId',
        name: 'AppointmentNewSpaceCoordination',
        component: () =>
          import(
            '@/views/student/quotes/AppointmentNewSpaceCoordinationWrapper.vue'
          ),
      },
      {
        path: 'coordination',
        name: 'AppoinmentCoordination',
        component: () =>
          import('@/views/student/quotes/AppointmentCoordinationWrapper.vue'),
      },
      {
        path: 'historical/:client',
        name: 'HistoricalAppointmentManagement',
        component: () =>
          import('@/views/student/quotes/AppointmentHistoricalWrapper.vue'),
      },
      {
        path: 'speechAndLanguage/:client/:appointmentId/:sie',
        name: 'SpeechAndLanguage',
        props: true,
        component: () =>
          import('@/views/student/quotes/SpeechAndLanguageWrapper.vue'),
      },
    ],
  },
  {
    path: '/student/RequestServiceMonitoring',
    name: 'ProvisionalRemedyAnswer',
    component: () => import('@/views/student/provisionalRemedyAnswer/Main.vue'),
  },
  {
    path: '/student/RequestServiceMonitoring/documents/:requestId',
    name: 'rpanswerdocuments',
    component: () =>
      import(
        '@/views/student/provisionalRemedyAnswer/components/Documents.vue'
      ),
  },
  {
    path: '/student/StudentImpedimentTranHistory',
    name: 'StudentImpedimentTranHistory',
    component: () => import('@/views/student/CompuHistory/Main.vue'),
  },
  {
    path: '/student/sie-replacement',
    name: 'sieReplacement',
    component: () =>
      import('@/views/student/sieReplacement/SieReplacement.vue'),
  },
  {
    path: '/student/online-registry',
    name: 'StudentOnlineRegistry',
  },
  ...studentRoutes,
];
